import { useEffect, useRef, useState } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useI18n, LANGUAGES } from "@/context/I18nContext";

export default function LanguageSwitcher({ compact = false }) {
    const { lang, setLanguage } = useI18n();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

    useEffect(() => {
        const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    return (
        <div className="relative" ref={ref}>
            <button
                onClick={() => setOpen((o) => !o)}
                data-testid="language-switcher"
                aria-label="Change language"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200"
            >
                {compact ? <Globe size={16} /> : <span className="text-base leading-none">{current.flag}</span>}
                <span className="hidden sm:inline uppercase tracking-wider text-xs font-bold">{current.code}</span>
                <ChevronDown size={14} className="opacity-60" />
            </button>
            {open && (
                <div className="absolute right-0 top-full mt-2 w-44 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl shadow-floating z-50 overflow-hidden" data-testid="language-menu">
                    {LANGUAGES.map((l) => (
                        <button
                            key={l.code}
                            onClick={() => { setLanguage(l.code); setOpen(false); }}
                            data-testid={`language-option-${l.code}`}
                            className={`w-full text-left px-4 py-2 text-sm flex items-center gap-3 hover:bg-slate-50 dark:hover:bg-slate-800 ${lang === l.code ? "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300 font-semibold" : "text-slate-700 dark:text-slate-200"}`}
                        >
                            <span className="text-base">{l.flag}</span>{l.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
